// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.1673 5.33301V3.46634C11.1673 2.7196 11.1673 2.34624 11.022 2.06102C10.8942 1.81014 10.6902 1.60616 10.4393 1.47833C10.1541 1.33301 9.78072 1.33301 9.03398 1.33301H3.96732C3.22058 1.33301 2.84721 1.33301 2.562 1.47833C2.31111 1.60616 2.10714 1.81014 1.97931 2.06102C1.83398 2.34624 1.83398 2.7196 1.83398 3.46634V8.53301C1.83398 9.27974 1.83398 9.65311 1.97931 9.93833C2.10714 10.1892 2.31111 10.3932 2.562 10.521C2.84721 10.6663 3.22058 10.6663 3.96732 10.6663H5.83398M8.50065 9.99967L9.83398 11.333L12.834 8.33301M7.96732 14.6663H13.034C13.7807 14.6663 14.1541 14.6663 14.4393 14.521C14.6902 14.3932 14.8942 14.1892 15.022 13.9383C15.1673 13.6531 15.1673 13.2797 15.1673 12.533V7.46634C15.1673 6.7196 15.1673 6.34624 15.022 6.06102C14.8942 5.81014 14.6902 5.60616 14.4393 5.47833C14.1541 5.33301 13.7807 5.33301 13.034 5.33301H7.96732C7.22058 5.33301 6.84721 5.33301 6.562 5.47833C6.31111 5.60616 6.10714 5.81014 5.97931 6.06102C5.83398 6.34624 5.83398 6.7196 5.83398 7.46634V12.533C5.83398 13.2797 5.83398 13.6531 5.97931 13.9383C6.10714 14.1892 6.31111 14.3932 6.562 14.521C6.84721 14.6663 7.22058 14.6663 7.96732 14.6663Z"
    />
  </svg>
);
const IconSelection = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconSelection;
